
const SkipLink = ({ description = 'Skip to content', href, contentRef, skipToSamePage = true }) => {
  return (
    <a className="skip" href={href} onClick={(e) => {
      if (skipToSamePage=== true) {
        e.preventDefault(); // Stop HashRouter
      }
      contentRef.current?.focus();
    }}>
      {description}
    </a>
  );
};

export default SkipLink;